/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
export const SAVE_ASSET = "SAVE_ASSET";
export const SUCCESS_SAVE_ASSET = "SUCCESS_SAVE_ASSET";
export const FAILURE_SAVE_ASSET = "FAILURE_SAVE_ASSET";

export const ASSET_LIST_REQUEST = "ASSET_LIST_REQUEST";
export const ASSET_LIST_SUCCESS = "ASSET_LIST_SUCCESS";
export const ASSET_LIST_FAILURE = "ASSET_LIST_FAILURE";

export const ASSET_DETAIL_REQUEST = "ASSET_DETAIL_REQUEST";
export const ASSET_DETAIL_SUCCESS = "ASSET_DETAIL_SUCCESS";
export const ASSET_DETAIL_FAILURE = "ASSET_DETAIL_FAILURE";

export const DELETE_ASSET = "DELETE_ASSET";
export const DELETE_ASSET_SUCCESS = "DELETE_ASSET_SUCCESS";
export const DELETE_ASSET_FAILURE = "DELETE_ASSET_FAILURE";
export const RESET_ASSET_DELETE = "RESET_ASSET_DELETE";

export const RESET_BASIC_INFO = "RESET_BASIC_INFO";

export const LOOKUP_ASSET = "LOOKUP_ASSET";
export const LOOKUP_ASSET_SUCCESS = "LOOKUP_ASSET_SUCCESS";
export const LOOKUP_ASSET_FAILURE = " LOOKUP_ASSET_FAILURE";

export const HAS_ASSET = "HAS_ASSET";
export const HAS_ASSET_SUCCESS = "HAS_ASSET_SUCCESS";
export const HAS_ASSET_FAILURE = "HAS_ASSET_FAILURE";

export const RESET_ASSET_LIST = "RESET_ASSET_LIST";

export const SAVE_ASSET_NOT_FOUND_LOG = "SAVE_ASSET_NOT_FOUND_LOG";

export const BULK_ADD_ASSET = "BULK_ADD_ASSET";
export const BULK_ADD_ASSET_SUCCESS = "BULK_ADD_ASSET_SUCCESS";
export const BULK_ADD_ASSET_FAILURE = "BULK_ADD_ASSET_FAILURE";

export const DOWNLOAD_BULK_ADD_CSV = "DOWNLOAD_BULK_ADD_CSV";

export const LOOKUP_PARCEL = "LOOKUP_PARCEL";
export const LOOKUP_PARCEL_SUCCESS = "LOOKUP_PARCEL_SUCCESS";
export const LOOKUP_PARCEL_FAILURE = "LOOKUP_PARCEL_FAILURE";

export const ADD_ASSET_AND_FINANCIALS = "ADD_ASSET_AND_FINANCIALS";
export const ADD_ASSET_AND_FINANCIALS_SUCCESS =
  "ADD_ASSET_AND_FINANCIALS_SUCCESS";
export const ADD_ASSET_AND_FINANCIALS_FAILURE =
  "ADD_ASSET_AND_FINANCIALS_FAILURE";

export const RESET_ADD_ASSET = "RESET_ADD_ASSET";

export const ADD_ENTITY = "ADD_ENTITY";
export const ADD_ENTITY_SUCCESS = "ADD_ENTITY_SUCCESS";
export const ADD_ENTITY_FAILURE = "ADD_ENTITY_FAILURE";

export const GET_ENTITIES = "GET_ENTITIES";
export const GET_ENTITIES_SUCCESS = "GET_ENTITIES_SUCCESS";
export const GET_ENTITIES_FAILURE = "GET_ENTITIES_FAILURE";
